/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RequestAuditObservabilityStages {
    getFixupPrototypeFunction() { return RequestAuditObservabilityStages.fixupPrototype; }

    static newInstance(model: Partial<RequestAuditObservabilityStages>): RequestAuditObservabilityStages {
        let obj = Object.assign(new RequestAuditObservabilityStages(), model);
        RequestAuditObservabilityStages.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RequestAuditObservabilityStages>): RequestAuditObservabilityStages {
        if (!model) return null;
        return RequestAuditObservabilityStages.newInstance(<RequestAuditObservabilityStages> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RequestAuditObservabilityStages) {
        if (!obj) return;

        models.RequestAuditObservabilityStages.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RequestAuditObservabilityStages): boolean {
        Object.setPrototypeOf(obj, RequestAuditObservabilityStages.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_ms === undefined) {
            this.total_ms = 0;
        }
    }

    /**
     * Code path taken within the handler.
     */
    path: string;

    /**
     * Additional information about the path.
     */
    additional_info: { [key: string]: string; };

    /**
     * Stage name to duration in milliseconds.
     */
    timings: { [key: string]: number; };

    /**
     * Total execution time in milliseconds.
     */
    total_ms: number;

    /**
     * Endpoint-specific counters (e.g. doc_count, identity_count).
     */
    counters: { [key: string]: number; };

}
